import { apiClient } from "../../../lib/apiClient"
import type { ApiResponse } from "../../../types/apiResponse";
import type { ChartAccountData } from "../types";

export const createChartAccount = async (body: ChartAccountData) => {
  return apiClient<ApiResponse<{ id: number }>>('/v1/catalogs/chart_account', {
    method: "POST",
    body
  });
}
